export default __webpack_public_path__ + "static/placeholder-black-19f39f76d78cc80b35459bf6962247d1.jpg";